import { defineBlock, ChildrenBlock } from '@smartfire/js-block-engine';
import style from './block.module.scss';

function ContactForm() {
    return (
        <ChildrenBlock
            gutenbergEditorConfig={{
                template: [['smartfire/contact---form---form-header'], ['smartfire/contact---form---form-content']],
                templateLock: 'all',
            }}
            className={style.blockForm}
        />
    );
}

export default defineBlock({
    Block: ContactForm,
    smartProps: {},
    setup: {
        title: 'Formulaire de contact',
        parent: ['smartfire/contact'],
    },
});
